import * as React from 'react';

export function FullBodyGrip3(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width={27} height={56} viewBox="0 0 27 56" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M15.647 21.546a1.6 1.6 0 01-.613 1.078 1.63 1.63 0 01-1.2.33 1.7 1.7 0 01-.884-.381 7 7 0 01-.317-.358 5 5 0 01-.547-.817c-.31-.584-.302-.86-.553-1.38-.299-.66-.49-.604-1.315-1.66a15.7 15.7 0 01-1.43-2.17q-.147-.287-.274-.53l-.012-.018c-.109-.234-.212-.449-.287-.616a2.15 2.15 0 01-.092-.922 2.36 2.36 0 01.904-1.58 2.38 2.38 0 011.764-.474 2.47 2.47 0 011.52.752l.014.02c.116.174.222.332.346.479q.005.016.017.025a8 8 0 01.974 2.008c.173.578.308 1.25.308 1.25.107.563.09.644.196 1.138.083.481.218.952.404 1.404.185.446.43.866.727 1.247a1.58 1.58 0 01.35 1.175"
				fill="#8c8c8c"
			/>
			<path
				d="M19.14 27.986a1.18 1.18 0 01-.947.88 1.19 1.19 0 01-1.193-.51 26 26 0 01-4.485-6.394 1.47 1.47 0 01-.258-1.17 1.55 1.55 0 011.248-1.156 1.57 1.57 0 011.568.67 9.6 9.6 0 011.563 2.5c.3.725.344 1.098.654 1.829a9 9 0 001.412 2.219 1.13 1.13 0 01.438 1.133"
				fill="#8c8c8c"
			/>
			<mask
				id="a"
				style={{
					maskType: 'luminance'
				}}
				maskUnits="userSpaceOnUse"
				x={16}
				y={26}
				width={8}
				height={8}
			>
				<path d="M23.793 30.605l-3.582 2.924-3.772-4.562 3.582-2.924z" fill="#fff" />
			</mask>
			<g mask="url(#a)">
				<path
					d="M20.036 32.113c.127-.12.042-.287-.073-.423l-.765-.811 1.237 1.312c.088.11.282.293.443.196.162-.098.112-.341-.034-.508.192.283.428.502.605.373.117-.085.129-.248.016-.403l-1.385-1.604 1.182 1.369c.122.147.319.293.453.183.135-.11.08-.29-.017-.45 0 0-.895-1.298-1.099-1.527-.207-.254-.674-.826-.597-.993.168.075.353.136.555.29.233.148.664.111.812-.057.177-.275-.357-.426-.584-.577-.697-.463-.99-.725-1.472-.89-.322-.117-.672-.302-1.32.103-.763.639-.814 1.268.29 2.804.251.34 1.205 1.378 1.417 1.536.131.099.254.155.336.077"
					fill="#8c8c8c"
				/>
			</g>
			<path
				d="M14.649 14.568c.099.422.268 1.419-1.264 5.934-.771 2.268-1.035 2.655-1.142 3.81-.095.954-.215 1.356-.22 2.434-.003.506-.014 1-.008 1.111.061 1.098-.178 2.17-.441 2.789a3.76 3.76 0 01-2.597 1.205 3.84 3.84 0 01-3.133-1.314 9 9 0 01-.532-.818 6.5 6.5 0 01-.99-3.396c.016-.574.11-1.144.279-1.694q.32-.845.75-1.641s.389-.852.665-1.692c.277-.84.315-1.522.302-3.47-.02-2.783-.087-3.25-.058-3.724 0 0 .006-.205.04-.388.159-1.174 1.083-2.52 1.176-2.658.714-1.023.923-.965 1.658-2.095.285-.381.505-.805.653-1.255.31-1.118-.22-1.703.128-2.112.434-.512 1.73-.193 2.521.23 1.235.648 2.146 2.061 1.87 2.957a1.3 1.3 0 01-.37.641c-.316.276-.65.214-.872.52a.9.9 0 00-.15.477c-.034.571.4.816.857 1.582.422.807.718 1.672.878 2.567"
				fill="#8c8c8c"
			/>
			<path
				d="M16.996 5.33a9.3 9.3 0 01-.205 1.686 10 10 0 01-.38 1.214 4.4 4.4 0 01-.655 1.326 1.5 1.5 0 01-.602.53 1.72 1.72 0 01-1.32-.138 3 3 0 01-.745-.493c-.326-.27-.357-.378-.718-.722a8 8 0 00-.811-.663c-.726-.532-.779-.408-1.137-.724a3.1 3.1 0 01-.911-1.514 4.2 4.2 0 01-.077-1.101 3.75 3.75 0 011.347-2.497 3.81 3.81 0 015.275.416c.651.737.987 1.697.936 2.676z"
				fill="#bfbfbf"
			/>
			<rect x={15.169} y={27.458} width={8.306} height={5.597} rx={1.083} fill="#8c8c8c" />
			<path
				d="M14.895 22.048a1.6 1.6 0 01-.613 1.078 1.63 1.63 0 01-1.2.33 1.7 1.7 0 01-.885-.381 7 7 0 01-.317-.358 5 5 0 01-.546-.817c-.31-.583-.303-.86-.554-1.38-.298-.66-.49-.604-1.315-1.66a15.7 15.7 0 01-1.43-2.17q-.146-.287-.274-.53l-.012-.018c-.108-.234-.211-.449-.287-.616a2.15 2.15 0 01-.092-.922 2.36 2.36 0 01.904-1.58 2.38 2.38 0 011.765-.474c.58.064 1.118.33 1.52.752l.014.02c.116.174.222.332.346.479q.003.015.017.025c.418.62.745 1.297.974 2.008.172.578.308 1.25.308 1.25.107.563.09.644.195 1.138.083.481.219.952.404 1.404.185.446.43.866.727 1.247a1.58 1.58 0 01.35 1.175"
				fill="#bfbfbf"
			/>
			<path
				d="M9.957 43.434c-.27.44-.709.75-1.219.865s-1.05.024-1.503-.252a2.1 2.1 0 01-.787-.827 2.04 2.04 0 01-.233-1.103s.017-.018.006-.044l.057-.262.006-.063q.117-.757.097-1.525a9.4 9.4 0 00-.502-2.648 48 48 0 01-1.268-5.092c-.201-1.12-.3-2.253-.294-3.386a.3.3 0 01-.006-.091q-.006-.249.02-.495a3.4 3.4 0 01.476-1.518 3.68 3.68 0 012.336-1.668 3.9 3.9 0 012.888.484c.363.218.69.491.97.808.6.747.944 1.66.978 2.601.18 1.688-.018 2.816-.29 5.046-.375 3.096-.24 2.879-.494 4.371a34 34 0 01-1.05 4.4s-.02.023-.016.047a1.7 1.7 0 01-.172.352m4.623 11.64c-.099.423-.652.591-.935.67s-.436.068-1.628.041a6 6 0 01-1.039-.04c-.553-.108-.643-.272-1.194-.42a4.3 4.3 0 00-1.32-.14c-.805.021-.903.218-1.637.192a2.3 2.3 0 01-1.17-.283 1.37 1.37 0 01-.6-.646c-.145-.386.003-.767.302-1.516q.2-.49.45-.959.109-.257.14-.534-.001-.258.056-.51a.95.95 0 01.383-.437 1.328 1.328 0 012.048.574q.6.686 1.299 1.275.606.482 1.259.9c.354.282.755.501 1.184.647q.424.086.855.121c1.015.143 1.181.21 1.318.359a.78.78 0 01.228.706"
				fill="#8c8c8c"
			/>
			<path
				d="M10.366 42.847a37 37 0 01-.46 2.644c-.217 1.045-.4 1.58-.719 2.957a73 73 0 00-.675 3.064l-.003.043a1.3 1.3 0 01-.516.788 1.32 1.32 0 01-1.757-.202 1.3 1.3 0 01-.32-.885c.004-.085.03-.157.04-.234a15 15 0 00.143-1.855 5.8 5.8 0 00-.12-1.693c-.061-.227-.155-.477-.257-.912a7 7 0 01-.091-.891c-.027-.664.203-2.04.852-3.735a1.98 1.98 0 01.78-1.152 2.006 2.006 0 012.609.25c.33.347.523.802.543 1.28-.001.177-.027.36-.05.533"
				fill="#8c8c8c"
			/>
			<path
				d="M18.388 28.488a1.18 1.18 0 01-.948.88 1.19 1.19 0 01-1.192-.511 26 26 0 01-4.485-6.394 1.47 1.47 0 01-.258-1.17c.073-.293.23-.558.45-.763a1.56 1.56 0 011.682-.29c.278.12.516.317.684.567a9.6 9.6 0 011.562 2.5c.302.725.344 1.098.655 1.829a9 9 0 001.412 2.219 1.13 1.13 0 01.438 1.133"
				fill="#bfbfbf"
			/>
			<mask
				id="b"
				style={{
					maskType: 'luminance'
				}}
				maskUnits="userSpaceOnUse"
				x={15}
				y={26}
				width={9}
				height={9}
			>
				<path d="M23.04 31.107l-3.58 2.924-3.773-4.561 3.582-2.925z" fill="#fff" />
			</mask>
			<g mask="url(#b)">
				<path
					d="M19.284 32.615c.126-.12.042-.286-.073-.422l-.765-.812 1.237 1.312c.088.111.282.294.443.196s.111-.34-.034-.507c.192.282.428.502.605.373.117-.085.129-.249.016-.404l-1.385-1.604 1.182 1.37c.122.147.319.292.453.182.135-.11.08-.289-.017-.449 0 0-.895-1.299-1.099-1.527-.207-.255-.674-.826-.598-.993.168.075.354.136.556.29.233.148.663.11.811-.058.178-.275-.356-.426-.583-.576-.697-.463-.99-.725-1.473-.891-.32-.117-.671-.301-1.32.103-.762.64-.813 1.269.292 2.805.25.339 1.204 1.378 1.416 1.536.131.098.253.154.336.076"
					fill="#bfbfbf"
				/>
			</g>
		</svg>
	);
}
